<template>
  <div class="border border-divider rounded border-solid bg-wikitable">
    <slot />
  </div>
</template>
